import user_api from '@/api/user';
import { sendSuccessNotice, sendErrorNotice } from '@/commons/utils';
import Vue from 'vue';

const state = {
    token: '',
    user: {},
    resData: {},
};

const getters = {};

const actions = {
    login({ commit }, loginInfo) {   
        user_api.login(data => {
            commit('setToken', data);        
        }, Vue.http, loginInfo.email, loginInfo.password);
    },
    register({ commit }, loginInfo) {
        user_api.register(data => {
            commit('setToken', data);
            sendSuccessNotice('Đăng ký tài khoản thành công.')  
        }, Vue.http, loginInfo);
    },
    forgotPassword({ commit }, email) {
        user_api.forgotPass(data => {
            commit('forgotPass', data);
            sendSuccessNotice('Reset mật khẩu thành công. Vui lòng kiểm tra email.')
        }, Vue.http, email);
    }
    
};

const mutations = {
    setToken(state, data) {
        state.resData = data.data ? data.data : data;
        if(data.status_code == 400 || data.status_code == 202){
            localStorage.setItem('jwt', null);
            localStorage.setItem('user', null);
            return;
        }

        state.token = state.resData.token;
        state.user = state.resData.user;
        localStorage.setItem('jwt', state.resData.token);
        localStorage.setItem('user', JSON.stringify(state.resData.user));  
    },
    forgotPass(state, data) {
        state.resData = data.data ? data.data : data;
        if(data.status_code == 400 || data.status_code == 202){
            localStorage.setItem('jwt', null);
            localStorage.setItem('user', null);
            return;
        }
    },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
